import { fromEvent, merge, MonoTypeOperatorFunction, of, pipe } from 'rxjs';
import { mergeAll, windowToggle } from 'rxjs/operators';

export function ignoreDuringCompositions<T>(element: Element): MonoTypeOperatorFunction<T> {
  const openings$ = merge(of(undefined), fromEvent(element, 'compositionend'), fromEvent(element, 'blur'));
  const closes$ = fromEvent(element, 'compositionstart');

  return pipe(
    windowToggle(openings$, () => closes$),
    mergeAll(),
  );
}
